import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NgForOf } from '@angular/common';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterLink,
} from '@angular/router';
import { SidebarModule } from 'primeng/sidebar';
import { CommonModule } from '@angular/common';
import { getModuleAll } from '../../../core/utils/token-utils';
import { AuthService } from '../../services/auth.service';
import { LoadingService } from '../../../core/services/loading.service';
import { NotificationService } from './service/notification.service';
import { MenuModule } from 'primeng/menu';
import { SignalRService } from '../../../core/services/signalr.service';
import { Subscription } from 'rxjs';
import { HeaderService } from './service/header.service';
import { ActivatingMenuService } from '../../services/activating-menu.service';
@Component({
  selector: 'app-header',
  imports: [NgForOf, RouterLink, SidebarModule, CommonModule, MenuModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
  sidebarVisible: boolean = false;
  activeSubMenu: string | number | null = null;
  menuItems: any[] = [];
  currentUrl: string = '';
  notifications: any[] = []
  displayUserName: string = '';
  categoryCounts: Record<string, number> = {};
  renderMenuItems: any[] = [];
  activeSubMenuId: any = null;
  private signalRSubscription!: Subscription;
  private activeSubMenuSub!: Subscription;

  constructor(
    private router: Router,
    private authService: AuthService,
    public loadingService: LoadingService,
    public notificationService: NotificationService,
    private signalRService: SignalRService,
    private headerService: HeaderService,
    private activatingMenuService: ActivatingMenuService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loadingService.start();
      }

      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.loadingService.complete();
        this.activeSubMenu = null;
        this.activeChildMenu = null;
        if (event instanceof NavigationEnd) {
          this.currentUrl = this.router.url;
          this.autoExpandActiveMenu();
        }
      }
    });
  }

  ngOnInit() {
    this.currentUrl = this.router.url;
    this.loadMenu();
    this.loadCategoryCounts();
    this.authService.menuChanged$.subscribe(() => {
      this.loadMenu();
      this.loadCategoryCounts();
    });
    this.loadNotification()

    this.activeSubMenuSub = this.activatingMenuService.activatingSubMenu$.subscribe(id => {
      this.activeSubMenuId = id;
    });

    this.signalRService.startConnection();
    this.signalRSubscription = this.signalRService.notificationReceived.subscribe((notification: any) => {
      this.notifications.unshift(notification);
    });

    const user = localStorage.getItem('userInfo');
    if (user) {
      const userObj = JSON.parse(user);
      this.displayUserName = userObj.fullName || userObj.userName || '';
    }
  }

  async loadMenu() {
    const modules = JSON.parse(getModuleAll() || '[]');
    let tempMenuItems = this.mapModulesToMenu(modules);

    let lvIndex = tempMenuItems.findIndex(item => item.code === 'LV');
    // if (lvIndex === -1) {
    //   tempMenuItems.push({
    //     code: 'LV',
    //     name: 'Kế hoạch',
    //     subMenu: []
    //   });
    //   lvIndex = tempMenuItems.length - 1;
    // }



    this.menuItems = tempMenuItems;
    this.menuItems = this.prepareMenuItems(this.menuItems);
    this.activeSubMenu = null;
    this.activatingMenuService.setMenuItems(this.menuItems);
    this.updateRenderMenuItems();
    this.autoExpandActiveMenu();

    try {
      const res = await this.headerService.getLinhVuc();
      if (res && res.status === 'success') {
        const subMenuLV = res.data.map((item: any) => ({
          id: item.id,
          parentId: 'LV',
          name: item.name,
          code: item.code,
          routerPath: `/admin/bieu-mau/${item.id}`,
        }));

        const hardcodedMenu = {
          id: 'LV',
          parentId: null,
          code: 'LV',
          name: 'Kế hoạch',
          subMenu: subMenuLV
        };

        lvIndex = this.menuItems.findIndex(item => item.code === 'LV');
        if (lvIndex !== -1) {
          this.menuItems[lvIndex] = hardcodedMenu;
        }
        this.menuItems = [...this.menuItems];
        this.menuItems = this.prepareMenuItems(this.menuItems);
        this.activeSubMenu = null;
        this.activatingMenuService.setMenuItems(this.menuItems);
        this.updateRenderMenuItems();
        this.autoExpandActiveMenu();
      }
    } catch (err) {
      console.error('Error loading Linh Vuc menu:', err);
    }
  }

  async loadNotification() {
    try {
      const rs = await this.notificationService.GetAllNotifications()
      if (rs.status == "success") {
        this.notifications = rs.data
      }

      if (rs.status == 'error') {
        throw new Error(rs.message)
      }
    } catch (error) {
      console.log(error);
    }
  }

  async doReadNotification(id: number) {
    try {
      const rs = await this.notificationService.ReadNotification(id)
      if (rs.status == "success") {
        this.notifications = rs.data
        this.loadNotification()
      }

      if (rs.status == 'error') {
        throw new Error(rs.message)
      }
    } catch (error) {
      console.log(error);
    }
  }

  get unreadNotificationCount() {
    const total = this.notifications.filter(noti => !noti.read).length

    return total
  }

  mapModulesToMenu(modules: any[]): any[] {
    return modules.map((module) => this.mapModuleRecursive(module));
  }

  mapModuleRecursive(module: any): any {
    let routerPath = module.routerPath || '';
    let queryParams: any = null;

    if (routerPath.includes('?')) {
      const parts = routerPath.split('?');
      routerPath = parts[0];
      const queryStr = parts[1];
      const params = new URLSearchParams(queryStr);
      queryParams = {};
      params.forEach((value, key) => {
        queryParams[key] = value;
      });
    }

    return {
      id: module.id,
      parentId: module.parentId,
      code: module.code,
      name: module.name,
      icon: module.faIcon,
      routerPath: routerPath,
      queryParams: queryParams,
      subMenu:
        module.subModules?.map((child: any) =>
          this.mapModuleRecursive(child)
        ) || [],
    };
  }

  getMenuKey(item: any): string | number {
    return item?.id ?? item?.code;
  }

  isSubMenuOpen(item: any): boolean {
    if (this.activeSubMenu == null) {
      return false;
    }
    return this.activeSubMenu === this.getMenuKey(item);
  }

  showSubMenu(item: any): void {
    this.activeSubMenu = this.getMenuKey(item);
  }

  hideSubMenu(item: any): void {
    if (this.activeSubMenu === this.getMenuKey(item)) {
      this.activeSubMenu = null;
    }
  }

  trackById(index: number, item: any) {
    return item.id ?? item.code ?? index;
  }

  goHome() {
    this.router.navigate(['/home']);
  }

  showUserMenu = false;

  toggleUserMenu(event: Event) {
    event.stopPropagation();
    this.showUserMenu = !this.showUserMenu;
  }

  showNotiMenu = false;

  toggleNotiMenu(event: Event) {
    event.stopPropagation();
    this.showNotiMenu = !this.showNotiMenu;
  }

  viewProfile() {
    // Navigate to profile page
    const user = localStorage.getItem("userInfo");
    if (user != null || user != undefined) {
      const userObj = JSON.parse(user);
      const userName = userObj?.userName as string;
      this.router.navigate(["admin/profile/" + userName])
    }

  }

  changePassword() {
    this.router.navigate(["/change-password"]);
    // Navigate to change password page
  }

  settings() {
    this.showUserMenu = false;
    // Navigate to settings page
  }

  logout() {
    this.authService.currentRoleName = null;
    //const tokenIAM = getTokenIAM();
    this.authService.logout();
    // this.appconfigService.getAppConfig().subscribe(res => {
    //   if (res.casAuthentication && tokenIAM){
    //     this.authenIAM.signout();
    //   }
    // });
  }

  activeChildMenu: any = null;

  showChildMenu(subItem: any) {
    this.activeChildMenu = subItem;
  }

  hideChildMenu(subItem: any) {
    if (this.activeChildMenu === subItem) {
      this.activeChildMenu = null;
    }
  }

  goToReport(child: any) {
    if (!child?.id) return;
    this.router.navigate(['/create-report', child.id]);
  }

  getMenuRouterLink(parent: any, menuItem: any): string | any[] | null {
    if (!menuItem) return null;

    const explicitRoute = menuItem.routerPath || menuItem.routePath || menuItem.path || menuItem.link || menuItem.url;
    if (explicitRoute) {
      return explicitRoute;
    }

    if (parent?.code === 'QLKH' || parent?._parent?.code === 'QLKH' || menuItem._parent?.code === 'QLKH' || menuItem._parent?._parent?.code === 'QLKH') {
      if (menuItem.code && menuItem.id) {
        return ['/plan/list', menuItem.code, menuItem.id];
      }
      return null;
    }

    return null;
  }

  getTopLevelParent(item: any): any {
    let current = item;
    while (current && current._parent) {
      current = current._parent;
    }
    return current;
  }

  getActivePlanTypes(): string[] {
    const urlWithoutQuery = (this.currentUrl || '').split('?')[0];
    const segments = urlWithoutQuery.split('/').filter(s => s);
    if (segments.length === 0) return [];

    // Helper: decode a URL-encoded segment then split by '|'
    const decodedSplit = (seg: string): string[] => {
      try { return decodeURIComponent(seg).toUpperCase().split('|'); }
      catch { return seg.toUpperCase().split('|'); }
    };

    // Check query parameters first
    const queryParams = this.getQueryParamMap(this.currentUrl);
    if (queryParams['planType']) {
      return queryParams['planType'].toUpperCase().split('|');
    }

    // Case 1: /plan-dashboard/:planType
    if (segments[0] === 'plan-dashboard' && segments[1]) {
      return decodedSplit(segments[1]);
    }

    // Case 2: /plan/...
    if (segments[0] === 'plan') {
      if ((segments[1] === 'ke-hoach-tct' || segments[1] === 'ke-hoach-don-vi' || segments[1] === 'list') && segments[2]) {
        return decodedSplit(segments[2]);
      }

      if (segments[1] === 'kehoachgiao') {
        return ['GIAO'];
      }

      if (segments[1] === 'kehoachthuchien') {
        return ['THUC_HIEN'];
      }

      if (segments[1] && !['versions', 'version', 'periodic-reports'].includes(segments[1])) {
        return decodedSplit(segments[1]);
      }
    }

    return [];
  }

  isMenuActive(item: any): boolean {
    if (!item) return false;

    // Filter active state by planType if we are on a plan page
    const activeTypes = this.getActivePlanTypes();
    if (activeTypes.length > 0) {
      const topParent = this.getTopLevelParent(item);
      if (topParent && this.isPlanCategoryMenu(topParent)) {
        const parentCode = this.getNormalizedMenuCode(topParent);
        if (!activeTypes.includes(parentCode)) {
          return false;
        }
      }
    }

    return this.itemOrChildMatchesUrl(item);
  }

  private itemOrChildMatchesUrl(item: any): boolean {
    if (!item) return false;
    // Check own routerPath first (handles leaf items AND top-level menus with their own path)
    if (this.itemUrlMatches(item)) return true;
    // Then recurse into children
    if (item.subMenu && item.subMenu.length > 0) {
      return item.subMenu.some((child: any) => this.itemOrChildMatchesUrl(child));
    }
    return false;
  }

  private itemUrlMatches(item: any): boolean {
    const routerPath = item.routerPath;
    if (!routerPath) return false;

    let url = (this.currentUrl || '').split('?')[0].replace(/\/+$/, '') || '/';
    try { url = decodeURIComponent(url); } catch (e) { /* ignore */ }

    let path = String(routerPath).split('?')[0].replace(/\/+$/, '') || '/';
    try { path = decodeURIComponent(path); } catch (e) { /* ignore */ }

    if (path === '/') {
      return url === '/' || url === '/home';
    }

    // Exact match
    let match = (url === path || url.startsWith(path + '/'));

    if (!match) {
      // For /plan/ routes: Angular redirects /plan/list/TYPE/ID → /plan/ke-hoach-tct/TYPE/ID
      // So skip the 2nd segment and compare the rest
      const urlSegs = url.split('/').filter(s => s);
      const pathSegs = path.split('/').filter(s => s);
      if (urlSegs[0] === 'plan' && pathSegs[0] === 'plan') {
        if (urlSegs.length >= 3 && pathSegs.length >= 3) {
          const urlRest = urlSegs.slice(2).join('/');
          const pathRest = pathSegs.slice(2).join('/');
          if (urlRest && pathRest && (urlRest === pathRest || urlRest.startsWith(pathRest + '/'))) {
            match = true;
          }
        }
        // Support detail route format: /plan/TYPE/update/ID matches /plan/list/TYPE/ID
        if (!match && urlSegs.length === 4 && pathSegs.length === 4) {
          const typeMatches = urlSegs[1] === pathSegs[2];
          const bieuMauMatches = this.activeSubMenuId !== null && this.activeSubMenuId !== undefined && String(item.id) === String(this.activeSubMenuId);
          if (typeMatches && bieuMauMatches) {
            match = true;
          }
        }
      }
    }

    if (match) {
      // Verify query parameters if they are specified in the menu item configuration
      const currentQueryMap = this.getQueryParamMap(this.currentUrl);
      const itemQueryMap = {
        ...this.getQueryParamMap(routerPath),
        ...(item.queryParams || {})
      };

      const itemKeys = Object.keys(itemQueryMap);
      if (itemKeys.length > 0) {
        for (const key of itemKeys) {
          const itemVal = String(itemQueryMap[key] ?? '').toLowerCase();
          const currentVal = String(currentQueryMap[key] ?? '').toLowerCase();
          if (itemVal !== currentVal) {
            return false; // Query parameter mismatch
          }
        }
      }
    }

    return match;
  }

  private getQueryParamMap(urlStr: string): { [key: string]: string } {
    const map: { [key: string]: string } = {};
    if (!urlStr || !urlStr.includes('?')) return map;
    const queryString = urlStr.split('?')[1];
    if (!queryString) return map;
    const pairs = queryString.split('&');
    for (const pair of pairs) {
      const parts = pair.split('=');
      if (parts[0]) {
        map[parts[0]] = decodeURIComponent(parts[1] || '');
      }
    }
    return map;
  }

  private prepareMenuItems(items: any[], parent: any = null): any[] {
    return items.map((item: any, index: number) => {
      const keySegment = item?.id ?? item?.code ?? `item${index}`;
      const indexSuffix = parent ? `${index}` : `root${index}`;
      const itemKey = parent ? `${parent._key}/${keySegment}-${indexSuffix}` : `${keySegment}-${indexSuffix}`;

      const normalizedItem = {
        ...item,
        _key: itemKey,
        _parent: parent,
      };

      if (normalizedItem.subMenu && normalizedItem.subMenu.length > 0) {
        normalizedItem.subMenu = this.prepareMenuItems(normalizedItem.subMenu, normalizedItem);
      }

      return normalizedItem;
    });
  }

  getNormalizedMenuCode(item: any): string {
    const cleanName = this.cleanString(item.name || '');
    if (cleanName.includes('lapkehoach') || cleanName === 'lap') {
      return 'LAP';
    }
    if (cleanName.includes('tonghop') || cleanName === 'tonghopkehoach') {
      return 'TONG_HOP';
    }
    if (cleanName.includes('giaokehoach') || cleanName === 'giao') {
      return 'GIAO';
    }
    if (cleanName.includes('thuchien') || cleanName === 'thuchienkehoach') {
      return 'THUC_HIEN';
    }
    if (cleanName.includes('dieuchinh') || cleanName === 'dieuchinhkehoach') {
      return 'DIEU_CHINH';
    }
    if (item.code) {
      return item.code.toUpperCase();
    }
    return item.id ? String(item.id) : 'UNKNOWN';
  }

  updateRenderMenuItems() {
    this.renderMenuItems = this.menuItems.map(item => {
      if (this.isPlanCategoryMenu(item)) {
        const menuCode = this.getNormalizedMenuCode(item);
        return {
          ...item,
          routerPath: `/plan-dashboard/${menuCode}`
        };
      }
      return item;
    });
    this.renderMenuItems = this.prepareMenuItems(this.renderMenuItems);
  }

  private autoExpandActiveMenu(): void {
    // No-op: active state is now computed directly in isMenuActive/itemOrChildMatchesUrl
    // Trigger change detection by reassigning renderMenuItems
    this.renderMenuItems = [...this.renderMenuItems];
  }

  async loadCategoryCounts() {
    try {
      const res = await this.headerService.getCategoryCounts();
      if (res && res.status === 'success' && Array.isArray(res.data)) {
        const counts: Record<string, number> = {};
        let total = 0;
        res.data.forEach((item: any) => {
          if (item.code) {
            counts[item.code.toUpperCase()] = item.count || 0;
            total += item.count || 0;
          }
        });
        counts['ALL'] = total;
        this.categoryCounts = counts;
      }
    } catch (error) {
      console.error('Error loading category counts in header:', error);
    }
  }

  cleanString(str: string): string {
    return str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/g, '');
  }

  shouldNavigateOnClick(item: any): boolean {
    if (!item) return false;

    // 1. Plan category menus
    if (this.isPlanCategoryMenu(item)) {
      return true;
    }

    // 2. Tab "Quản lý kế hoạch điện tử" (link '/thong-ke-chi-tieu')
    const cleanName = this.cleanString(item.name || '');
    const routerPath = item.routerPath || item.routePath || '';
    if (cleanName.includes('quanlykehoachdientu') || routerPath.includes('/thong-ke-chi-tieu')) {
      return true;
    }

    return false;
  }

  isPlanCategoryMenu(item: any): boolean {
    if (!item || !item.subMenu || item.subMenu.length === 0) return false;
    
    // Check if any sub-item has a name matching plan categories
    const planNames = [
      'dau tu xay dung', 'sua chua lon', 'truyen thong', 'khach hang', 
      'ky thuat', 'nhan su', 'dien luc', 'tai chinh', 'an toan', 
      'don vi', 'san xuat kinh doanh', 'tai san', 'kinh doanh'
    ].map(n => this.cleanString(n));
    
    const hasCategorySubItem = item.subMenu.some((sub: any) => {
      const name = this.cleanString(sub.name || '');
      return planNames.some(pName => name.includes(pName));
    });
    
    return hasCategorySubItem || item.code === 'LV';
  }

  getCategoryCardProps(subItem: any) {
    const code = (subItem.code || '').toUpperCase();
    const name = subItem.name || '';
    
    let icon = 'pi pi-file';
    let cardClass = 'card-default';
    
    const cleanName = this.cleanString(name);
    
    if (code === 'DTXD' || cleanName.includes('dautuxaydung')) {
      icon = 'pi pi-wrench';
      cardClass = 'card-xaydung';
    } else if (code === 'SCL' || cleanName.includes('suachualon')) {
      icon = 'pi pi-briefcase';
      cardClass = 'card-suachua';
    } else if (code === 'TT' || cleanName.includes('truyenthong')) {
      icon = 'pi pi-megaphone';
      cardClass = 'card-truyenthong';
    } else if (code === 'KDDV' || cleanName.includes('khachhang') || (cleanName.includes('kinhdoanh') && cleanName.includes('dichvu'))) {
      icon = 'pi pi-users';
      cardClass = 'card-khachhang';
    } else if (code === 'QLKT' || cleanName.includes('kythuat')) {
      icon = 'pi pi-cog';
      cardClass = 'card-kythuat';
    } else if (code === 'NSL' || cleanName.includes('nhansu')) {
      icon = 'pi pi-user-plus';
      cardClass = 'card-nhansu';
    } else if (code === 'DVDL' || cleanName.includes('dienluc')) {
      icon = 'pi pi-bolt';
      cardClass = 'card-dienluc';
    } else if (code === 'TC' || cleanName.includes('taichinh')) {
      icon = 'pi pi-wallet';
      cardClass = 'card-taichinh';
    } else if (code === 'ANTOAN' || cleanName.includes('antoan')) {
      icon = 'pi pi-shield';
      cardClass = 'card-antoan';
    } else if (code === 'KHDVX' || cleanName.includes('donvix')) {
      icon = 'pi pi-file';
      cardClass = 'card-donvix';
    } else if (code === 'SXKD' || cleanName.includes('sanxuat')) {
      icon = 'pi pi-building';
      cardClass = 'card-sxkd';
    } else if (code === 'TNTSKH' || cleanName.includes('taisan')) {
      icon = 'pi pi-copy';
      cardClass = 'card-taisan';
    } else if (code === 'KD' || cleanName.includes('kinhdoanh')) {
      icon = 'pi pi-shopping-cart';
      cardClass = 'card-kinhdoanh';
    }

    let value = 0;
    
    // Match the count value by code or cleanName fallback
    if (this.categoryCounts[code]) {
      value = this.categoryCounts[code];
    } else {
      const countKeys = Object.keys(this.categoryCounts);
      const matchedKey = countKeys.find(key => {
        if (key === 'DTXD' && cleanName.includes('dautuxaydung')) return true;
        if (key === 'SCL' && cleanName.includes('suachualon')) return true;
        if (key === 'TT' && cleanName.includes('truyenthong')) return true;
        if (key === 'KDDV' && (cleanName.includes('khachhang') || (cleanName.includes('kinhdoanh') && cleanName.includes('dichvu')))) return true;
        if (key === 'QLKT' && cleanName.includes('kythuat')) return true;
        if (key === 'NSL' && cleanName.includes('nhansu')) return true;
        if (key === 'DVDL' && cleanName.includes('dienluc')) return true;
        if (key === 'TC' && cleanName.includes('taichinh')) return true;
        if (key === 'ANTOAN' && cleanName.includes('antoan')) return true;
        if (key === 'SXKD' && cleanName.includes('sanxuat')) return true;
        if (key === 'TNTSKH' && cleanName.includes('taisan')) return true;
        if (key === 'KD' && cleanName.includes('kinhdoanh')) return true;
        return false;
      });
      if (matchedKey) {
        value = this.categoryCounts[matchedKey];
      }
    }

    return { icon, cardClass, value };
  }

  // Close menu when clicking outside
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    this.showUserMenu = false;
    this.showNotiMenu = false;
  }

  ngOnDestroy(): void {
    if (this.signalRSubscription) {
      this.signalRSubscription.unsubscribe();
    }
    if (this.activeSubMenuSub) {
      this.activeSubMenuSub.unsubscribe();
    }
  }
}
